import React, { Component } from 'react';
import { routes } from '../../../../utility/constants/constants';
import InventoryList from '../../../component/Inventory/InventoryListComponent/InventoryList';
import * as actions from '../../../../redux/actions/index';
import { connect } from 'react-redux';
import { reset } from 'redux-form';
import { animateScroll as scroll} from 'react-scroll'
import storage from '../../../../utility/storage';
import { convertDateToDifferentTZ } from '../../../../utility/utility';
import ScheduledTask from '../../../component/TimeTrackerModuleComponent/ScheduledTaskComponent/ScheduledTask';
import { tzUTCDateConverterTool_V2 } from '../../../../utility/TimezoneOperations/timezoneUtility';

var moment = require('moment');
const cloneDeep = require('clone-deep');

class ScheduledTaskContainer extends Component {

    constructor(props) {
        super(props);

        this.state = {
            
        }
    }

    componentDidMount() {
        scroll.scrollToTop();
    }

    componentDidUpdate(prevProps, prevState) {
        const user = storage.get('user');
        if(user) {
            if(prevProps.user.selected_mode !== user.selected_mode) {
                this.props.scheduledTaskListPageClicked(0)
            }
        }
    }

    resetClicked = () => {
        const page = 1
        const limit = this.props.scheduledTaskList_no_of_rows
        this.props.reset('searchScheduledTask');
        this.props.scheduledTaskListPageClicked(0)
        this.props.getScheduledTask({page,limit})

    }

    searchInventoryItemsListClicked = (value) => {
        const values = cloneDeep(value)
        let accountId =  null;
        let taskName = null;
        let companyName = null;
        let accountName = null;
        let from = null;
        let to = null;
    
        const page = 1
        const limit = this.props.scheduledTaskList_no_of_rows
        if(values.id) {
            values.id = values.id.trim()
            accountId = values.id
        }
      if(values.name) {
          values.name = values.name.trim()
          taskName = values.name
      }
      if(values.company) {
        values.company = values.company.trim()
        companyName = values.company
      }
      if(values.job) {
        values.job = values.job.trim()
        accountName =  values.job 
        }  
      if(values.fromDate) {
        from = tzUTCDateConverterTool_V2(values.fromDate, 'from');
      }  
      if(values.toDate) {
        to = tzUTCDateConverterTool_V2(values.toDate, 'to');
      }  
     
        this.props.getScheduledTask({page,limit,accountId,taskName,companyName,accountName,from,to}, values);
    }

    addInventoryItemClicked = () => {
        this.props.history.push(routes.NEW_INVENTORY_ITEM);
    }

    deleteInventoryItem = (id) => {
        this.props.deleteInventoryItem(id);
    }

    handleInventoryOpenDeleteModal = (value) => {
        this.props.handleInventoryOpenDeleteModal(value);
    }

    handleInventoryCloseDeleteModal = () => {
        this.props.handleInventoryCloseDeleteModal();
    }

    newTicketClicked = () => {
        this.props.resetObjects();
        this.props.history.push(routes.NEW_SCHEDULED_TASK);
    }
         
    render() {
        return (
            <ScheduledTask
                {...this.props}
                isLoading={this.props.isLoading}
                onSubmit={this.searchInventoryItemsListClicked}
                resetClicked={this.resetClicked}
                scheduledTaskList={this.props.scheduledTaskList ? this.props.scheduledTaskList : []}
                addInventoryItemClicked={this.addInventoryItemClicked}
                deleteInventoryItem={this.deleteInventoryItem}
                handleInventoryOpenDeleteModal={this.handleInventoryOpenDeleteModal}
                handleInventoryCloseDeleteModal={this.handleInventoryCloseDeleteModal}
                newTicketClicked={this.newTicketClicked}
                
            />
        )
    }
}


const mapStateToProps = (state) => {
    return {
        user: state.authReducer.user,
        isLoading: state.TimeTrackerModReducer.isLoading,
        scheduledTaskList: state.TimeTrackerModReducer.scheduledTaskList,
        isScheduledTaskList: state.TimeTrackerModReducer.isScheduledTaskList,
        scheduledTaskList_no_of_rows: state.TimeTrackerModReducer.scheduledTaskList_no_of_rows,
        scheduledTaskListCurPage: state.TimeTrackerModReducer.scheduledTaskListCurPage,
        openInventoryDeleteModal: state.TimeTrackerModReducer.openInventoryDeleteModal,
        deleteInventoryObject: state.TimeTrackerModReducer.deleteInventoryObject,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        reset: (searchInventoryItemsList) => dispatch(reset(searchInventoryItemsList)),  // requires form name
        scheduledTaskListPageClicked: (page) => dispatch(actions.scheduledTaskListPageClicked(page)),
        getScheduledTask: (params, values) => dispatch(actions.getScheduledTask(params, values)),
        deleteInventoryItem: (id) => dispatch(actions.deleteInventoryItem(id)),
        handleInventoryOpenDeleteModal: (value) => dispatch(actions.handleInventoryOpenDeleteModal(value)),
        handleInventoryCloseDeleteModal: () => dispatch(actions.handleInventoryCloseDeleteModal()),
        previewSingleScheduledTaskClicked: (ticket) => dispatch(actions.previewSingleScheduledTaskClicked(ticket)),
        resetObjects: () => dispatch(actions.resetObjects()),
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(ScheduledTaskContainer);